module.exports = __webpack_public_path__ + "img/edit.7e3d90c0.svg";